import React from 'react';
import {View} from 'react-native';
import Label from '../../Label';

interface Props {
  isRenewal: boolean;
}

export const Header = (props: Props) => {
  const {isRenewal} = props;
  return (
    <View>
      <Label
        title={`${isRenewal ? 'RENOUVELLEMENT' : 'SOUSCRIPTION'} RC VIE PRIVEE`}
        type="mainTitle"
      />
      <Label
        type="secondTitle"
        title={`Pour ${
          isRenewal ? 'renouveller' : 'souscrire'
        }, veuillez remplir les champs manquants`}
      />
    </View>
  );
};
